
export const linked_credit_notes = {
  invoiceNumber: "Invoice number",
  issueDate: "Issue date",
  expirationDate: "Expiration date",
  totalExcludeVat: "Total excl. VAT",
  totalIncludeVat: "Total incl. VAT",
  vat: "VAT"
};
